module.exports = __webpack_public_path__ + "img/cover-promotion-bg.e4a1f9bb.jpg";